/* *********************************
 *
 *      防災情報編集・確認画面
 *
 ********************************* */
/*-------------------
     モジュールのimport
 ---------------------*/
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import axios from 'axios';
import * as commons from './commons';

import { NGINX_PATH, API_PATH } from './constant/constant';
import Footer from './components/Footer';

// アイコンのimport
import folderIcon from './images/icon/folder.svg';

/**
 * 防災情報確認・編集
 *
 * @class SendDetail
 * @extends {React.Component}
 */
class audioPage extends React.Component {
  constructor(props) {
    super(props);
    // const { lgCd } = this.props.location;

    // audioタグのsrcを非表示にするためにcomponentDidMountからコンストラクタに移動 2020/09/15
    const url = this.props.location.pathname;
    const num = url.lastIndexOf('/');
    const path = url.slice(num + 1);
    // 市町村を取得する。
    const tmpLgCd = url.replace(`/${path}`, '');
    const num2 = tmpLgCd.lastIndexOf('/');
    const lgCd = tmpLgCd.slice(num2 + 1);

    //初期状態
    this.state = {
      push: true,
      lgCd,
      lgName: '',
      hideId: '',
      hideFlag: true,
      path: path.replace(/\.[^/.]+$/, ''), // 拡張子を除いた部分をpathにする。
      pageType: '',
      pageNum: 1,
      aodioTitle: '',
      sort: -1,
      targetMediaType: '',
      createdAt: '',
      // 追記
      speedRate: 1,
    };
  }

  /**
   * 一度目の描画終了時に実行される
   *
   * @memberof SendDetail
   */
  componentDidMount = async () => {
    document.title = '音声再生画面';
    const { lgCd, path } = this.state;

    // オーディオ設定マスタからヘッダーのタイトルを取得するように追記　2020/09/30
    const master = await commons.getAudioSet(lgCd);

    if (master === false) {
      window.alert('データの取得に失敗しました。');
      return;
    }

    const {
      title = '',
      none_extention: noneExtention = '.mp3',
      expiry_days: expiryDays = '',
    } = master;

    // 音声一覧画面に遷移してからもメソッドが走り続けてエラーになるため
    this.getDisplayData(lgCd, path, noneExtention, expiryDays);

    // 自治体マスタから市町村名を取得するように追記 2020/09/14
    const lgName = await commons.getLgName(lgCd);

    // 一覧・タイムライン画面から受け取った値の宣言
    const { state = {} } = this.props.location;
    const { pageType = 'blist' } = state;

    const hideId = setInterval(() => this.changeHideSrc(), 10);

    this.setState({
      hideId,
      lgName, // 追記 2020/09/14
      title, // 追記 2020/09/30
      pageType, // 追記 2020/09/30
    });
  };

  // ページを離れる際の処理
  componentWillUnmount = () => {
    // 音声ファイルが読み込めない場合にsetIntervalされたままになるのを防ぐために追加 2020/09/14
    const { hideId = '' } = this.state;
    clearInterval(hideId);
  };

  changeHideSrc = () => {
    // document.getElementById('audio')がnullの場合にエラーが発生しないように修正 2020/09/28
    // if (document.getElementById('audio').readyState === 4) {
    if (document.getElementById('audio') && document.getElementById('audio').readyState === 4) {
      const { hideId } = this.state;
      clearInterval(hideId);
      this.setState({
        hideFlag: false,
      });
    }
  };

  getDisplayData = async (lgCd, path, noneExtention, expiryDays) => {
    const { sort } = this.state;
    const data = await axios
      .post(`${API_PATH}/v/getDisplayData`, { lgCd, path, sort, expiryDays })
      .then(async (res) => {
        const getData = res.data[0];
        const {
          recv_comm: recvComm = { target_media_type: '' },
          send_contents: sendContents = {
            filename: '',
            title: '',
          },
          created_at: createdAt = '',
        } = getData;
        const { target_media_type: targetMediaType = '' } = recvComm;
        const { title = '', filename = '' } = sendContents;
        this.setState({ audioTitle: title, filename, createdAt, targetMediaType });
        return true;
      })
      .catch((err) => {
        window.alert('データの取得に失敗しました。');
        this.setState({ filename: `${path}${noneExtention}` });
        return false;
      });
    return data;
  };

  onPush = () => {
    const { speedRate = 1 } = this.state;
    if (this.state.push === true) {
      const audio = document.getElementById('audio');
      audio.play();
      audio.playbackRate = speedRate;
    } else {
      document.getElementById('audio').pause();
    }
  };

  onChange = () => {
    const { speedRate = 1 } = this.state;
    if (this.state.push === true) {
      const audio = document.getElementById('audio');
      // audio.play();
      audio.playbackRate = speedRate;
      this.setState({ push: false });
    } else {
      // document.getElementById('audio').pause();
      this.setState({ push: true });
    }
    //pushに入れるのはstateのpushの否定だと宣言
    // this.setState({ push: !this.state.push });
  };

  // 追記（2020.11.26）
  onEnd = () => {
    //pushに入れるのはstateのpushの否定だと宣言
    const audio = document.getElementById('audio');
    audio.currentTime = 0;
    audio.pause();
  };

  onSeek = () => {
    const audio = document.getElementById('audio');
    if (audio.playbackRate === 0) {
      this.setState({
        speedRate: 1,
      });
    }
  };

  changeSpeed = (speed) => {
    const audio = document.getElementById('audio');
    audio.playbackRate = speed;
    this.setState({ speedRate: speed });
  };

  handleToListPage = () => {
    const { history } = this.props;
    const { lgCd, filename, pageType } = this.state;
    history.push({
      pathname: `/${pageType}/${lgCd}`,
      state: {
        path: filename,
      },
    });
  };

  handleToWiniePage = (url) => {
    window.removeEventListener('scroll', this.watchScrollPositionList, true);
    const { history } = this.props;
    history.push({
      pathname: '/winie_01',
    });
  };

  /**
   * 防災情報編集・確認画面を描画する
   *
   * @memberof SendDetail
   */
  render() {
    const {
      push,
      lgCd,
      hideFlag,
      title,
      audioTitle,
      targetMediaType,
      createdAt,
      lgName,
      speedRate,
      filename = '',
    } = this.state;

    const url = filename === '' ? '' : `${NGINX_PATH}/${lgCd}/${filename}`;
    const date = commons.changeJapanDate(createdAt, 'YYYY年MM月DD日 (d) hh:mm:ss');

    return (
      <div className="back-colorForAudio">
        <div className="wrapp">
          <div className="titleContent">
            <a
              className="backList-btn"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                this.handleToListPage();
              }}
            >
              <div className="arrow"></div>
            </a>
            {/* 自治体マスタから情報を取得するように修正 */}
            {/* オーディオ設定マスタからタイトルを取得するように修正　2020.9.30 */}
            {<h1 className="title">{title ? title : null}</h1>}
          </div>
          <div className="audiocontents">
            <div>
              {/* svgをimportする形に変更 2020/09/29 */}
              <img src={folderIcon} alt="Folder Icon" style={{ width: '30%' }}></img>
            </div>
            <div>
              <div className="audiocontents-title">
                {/* 防災行政無線情報 */}
                {audioTitle !== '' ? <div>{audioTitle}</div> : null}
                {targetMediaType === 'Jアラート' ? <div>{date}</div> : null}
              </div>
            </div>
            <br />
            <div style={{ textAlign: 'center', width: '100%' }}>
              <audio
                id="audio"
                style={{ marginTop: '3%', width: '85%', border: 'none' }}
                controls
                controlsList="nodownload"
                onPlay={this.onChange}
                onPause={this.onChange}
                onEnded={() => this.onEnd()}
                onSeeked={this.onSeek}
              >
                {hideFlag === true && url !== '' ? <source src={url} type="audio/mpeg" /> : null}
              </audio>
            </div>
            <br />
            <div>
              <div className="btnBox">
                <button
                  className={speedRate === 0.8 ? 'speed-btnPushed' : 'speed-btn'}
                  onClick={() => this.changeSpeed(0.8)}
                >
                  0.8倍速
                </button>
                &emsp;
                <button
                  className={speedRate === 1 ? 'speed-btnPushed' : 'speed-btn'}
                  onClick={() => this.changeSpeed(1)}
                >
                  1.0倍速
                </button>
                &emsp;
                <button
                  className={speedRate === 1.5 ? 'speed-btnPushed' : 'speed-btn'}
                  onClick={() => this.changeSpeed(1.5)}
                >
                  1.5倍速
                </button>
              </div>
              <div className="btnBox">
                <button
                  className={speedRate === 1.8 ? 'speed-btnPushed' : 'speed-btn'}
                  onClick={() => this.changeSpeed(1.8)}
                >
                  1.8倍速
                </button>
                &emsp;
                <button
                  className={speedRate === 2 ? 'speed-btnPushed' : 'speed-btn'}
                  onClick={() => this.changeSpeed(2)}
                >
                  2.0倍速
                </button>
              </div>
              <div>
                <button className="start-btn" onClick={this.onPush}>
                  {push ? '再生' : '停止'}
                </button>
              </div>
            </div>

            <div className="infoBox">
              {/* <div> */}
              <ul>
                <li>
                  {`当ウェブページに掲載している音声コンテンツの著作権は、${lgName}に帰属しています。`}
                  <br />
                  著作権者の承諾なしに音声コンテンツを複製したり、他の媒体で再利用（転用）したりすることは、著作権法に触れる行為となります。
                </li>
                <li>
                  ご利用のブラウザによっては、音声の再生ができない場合があります。
                  <br />
                  <a href="../../help/aplay_ie11" target="_blank">
                    IE11の設定変更はこちら
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

audioPage.propTypes = {
  location: PropTypes.shape({
    info: PropTypes.object,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    length: PropTypes.number.isRequired,
  }).isRequired,
};

export default withRouter(audioPage);
